import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=d03344a4&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=d03344a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03344a4",
  null
  
)

export default component.exports